import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["name"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: { short: '', title: '' } }, "Please Select...", -1)
const _hoisted_3 = ["value"]

import states from "../assets/us_states.json";
import { State } from "@/models/State";
import { onMounted, ref, computed, Ref, ComputedRef } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsStatesBox',
  props: {
  initial: {
    default: new State(),
  },
  selectStyle: {
    default: "",
  },
  name: {
    default: "",
  },
},
  emits: ["input"],
  setup(__props, { emit }) {

const props = __props;


const value: Ref<any> = ref(new State());
const loaded: Ref<boolean> = ref(false);


const selected = computed({
  get: () => value.value,
  set: (newValue: string) => {
    (value.value = newValue), emit("input", newValue);
  },
});

const usStates: ComputedRef<any> = computed(() => {
  return states.states;
});

onMounted(() => {
  value.value = props.initial;
  loaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (loaded.value)
    ? _withDirectives((_openBlock(), _createElementBlock("select", {
        key: 0,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
        class: _normalizeClass(["plainfieldselect", __props.selectStyle]),
        name: __props.name
      }, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usStates.value, (state) => {
          return (_openBlock(), _createElementBlock("option", {
            key: state.short,
            value: state
          }, _toDisplayString(state.title), 9, _hoisted_3))
        }), 128))
      ], 10, _hoisted_1)), [
        [_vModelSelect, selected.value]
      ])
    : _createCommentVNode("", true)
}
}

})